import { useSyncExternalStore } from 'react'
import { UserEvent } from '../../constants/enums'
import { getUsersState } from '../../state/getState'
import { pubSubUsers } from '../../state/pubSub'

const subModelsLoaded = (callback: () => void) =>
    pubSubUsers.on(UserEvent.MODELS_LOADED, callback)

const getModelsLoaded = () => getUsersState().modelsLoaded

export const useModelsLoadedAppState = () => {
    const modelsLoaded = useSyncExternalStore(
        subModelsLoaded,
        getModelsLoaded,
        getModelsLoaded,
    )

    return modelsLoaded
}
